"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.symbol");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@emotion/core");

var emotion_theming_1 = require("emotion-theming");

var button_1 = require("../button/button");

var LinkVariant;

(function (LinkVariant) {
  LinkVariant["Default"] = "default";
  LinkVariant["Primary"] = "primary";
  LinkVariant["Secondary"] = "secondary";
})(LinkVariant = exports.LinkVariant || (exports.LinkVariant = {}));

exports.getLinkStyles = function (_ref) {
  var active = _ref.active,
      block = _ref.block,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      theme = _ref.theme,
      _ref$underline = _ref.underline,
      underline = _ref$underline === void 0 ? 'none' : _ref$underline,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? LinkVariant.Default : _ref$variant;
  var linkUnderline = underline === 'always' ? 'underline' : 'none';
  var linkUnderlineHover = underline === 'hover' || underline === 'always' ? 'underline' : 'none';
  var linkType = inverse ? 'inverse' : 'default';
  var _theme$links$variant$ = theme.links[variant][linkType],
      color = _theme$links$variant$.color,
      hover = _theme$links$variant$.hover,
      disabled = _theme$links$variant$.disabled;
  var hoverCss = {
    color: hover,
    textDecoration: linkUnderlineHover,
    ':visited': {
      color: hover
    }
  };
  var css = {
    color: color,
    display: block ? 'block' : 'inline-block',
    border: 'none',
    fontSize: 'inherit',
    textAlign: 'left',
    textDecoration: linkUnderline,
    cursor: 'pointer',
    ':visited': {
      color: color
    },
    ':hover,:focus': hoverCss,
    'a&:not([href])': {
      color: disabled,
      cursor: 'not-allowed'
    }
  };

  if (active) {
    css = Object.assign(Object.assign({}, css), hoverCss);
  }

  return css;
};

var LinkBase = function LinkBase(_a) {
  var href = _a.href,
      disabled = _a.disabled,
      _a$underline = _a.underline,
      underline = _a$underline === void 0 ? 'none' : _a$underline,
      children = _a.children,
      _a$buttonSize = _a.buttonSize,
      buttonSize = _a$buttonSize === void 0 ? 'regular' : _a$buttonSize,
      primary = _a.primary,
      secondary = _a.secondary,
      inverse = _a.inverse,
      asButton = _a.asButton,
      block = _a.block,
      theme = _a.theme,
      css = _a.css,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      active = _a.active,
      rest = __rest(_a, ["href", "disabled", "underline", "children", "buttonSize", "primary", "secondary", "inverse", "asButton", "block", "theme", "css", "className", "active"]);

  var variant;
  var baseCss = {};

  if (primary) {
    variant = LinkVariant.Primary;
  } else if (secondary) {
    variant = LinkVariant.Secondary;
  }

  if (asButton) {
    baseCss = button_1.getButtonStyles({
      theme: theme,
      variant: variant,
      block: block,
      active: active,
      size: buttonSize
    });
  } else {
    baseCss = exports.getLinkStyles({
      theme: theme,
      variant: variant,
      underline: underline,
      inverse: inverse,
      block: block,
      active: active
    });
  }

  return core_1.jsx("a", Object.assign({}, rest, {
    className: "" + className + (asButton ? ' is-button' : ''),
    href: disabled ? undefined : href,
    css: [baseCss, css]
  }), children);
};

var Link = emotion_theming_1.withTheme(LinkBase);
exports["default"] = Link;